import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";

import { type FlightFilters } from "@/features/flights/types/types";

export interface FlightFiltersContextValue {
  filters: FlightFilters | null;
  defaultFilters: FlightFilters | null;
  activeFilters: Record<keyof FlightFilters, boolean> | null;
  updateFilters: Dispatch<SetStateAction<FlightFilters | null>>;
}

export const FlightFiltersContext =
  createContext<FlightFiltersContextValue | null>(null);

export const useFlightFiltersContext = () => {
  const context = useContext(FlightFiltersContext);
  if (!context) {
    throw new Error(
      "useFlightFiltersContext must be used within a FlightFiltersProvider",
    );
  }
  return context;
};
